import React, {Component} from 'react'

import LoginForm from '../../components/LoginForm'
import './Splash.css'
import TempoLiberoLogo from '../../assets/tempolibero_logo.png'

import SplashBtn from '../../components/SplahsBtn'

import HeaderComponent from '../../components/HeaderComponent'

export default class Splash extends Component {
  render () {
    const {onPasswordForgot, onSubmit, onRegisterClick} = this.props

    return (<div>
      <HeaderComponent />
      <div className="main-container container">

        <div className="row">
          <div className="col-md-6">
            <div className="panel panel-default splash-registration-div">
              <div className="splash-registration">
                <a href="#" className="btn-social btn-outline"><img className="splash-registration-logo" src={TempoLiberoLogo} /></a>
              </div>
              <p style={{textAlign: 'justify', paddingLeft: 10, paddingRight: 10}}>
                Benvenuto sullo sportello on line del Piano Sosta della città di Empoli.
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                {/* Attraverso la registrazione al momento è possibile saldare il Pagamento 2018 (se dovuto),
                a seguire saranno attivate anche le funzioni di richiesta di rilascio di un nuovo contrassegno e/o richiesta di modifica di un contrassegno esistente,
                La possibilità di richiedere il rinnovo per l'anno 2019 sarà resa disponibile a partire dal prossimo 2 gennaio. */}
              </p>
              {/*<p>Benvenuti sullo sportello on line del Piano Sosta di Empoli.<br />
                Attraverso la registrazione sarà possibile<br /> richiedere, acquistare e gestire i propri contrassegni.</p>*/}
              <div className="splash-registration-btn">
                <SplashBtn onClick={onRegisterClick}>REGISTRATI</SplashBtn>
              </div>

            </div>
          </div>

          <div className="col-md-4 col-md-offset-1">
            <LoginForm
              onPasswordForgot={onPasswordForgot}
              onSubmit={onSubmit} />
          </div>

        </div>

      </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Splash/Splash.js